import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../../../Sidebar/Sidebar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { url } from "../../../App";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useNavigate } from "react-router-dom";

const EditBorrowerScreen = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const [motherTongue, setmotherTongue] = useState("");
  const [motherMaiden, setmotherMaiden] = useState("");
  const [category, setcategory] = useState("");
  const [religion, setreligion] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [title, setTitle] = useState("");
  const [gender, setGender] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fathersName, setFathersName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [educationalQualification, setEducationalQualification] = useState("");
  const [voterId, setVoterId] = useState("");
  const [borrowerEmail, setBorrowerEmail] = useState("");

  const handleUpdatePersonalDetails = (e) => {
    e.preventDefault();
    setOpen(true);
    if (voterId?.trim() === "") {
      setOpen(false);
      toast.error("Voter ID cannot be empty");
      return;
    }
    axios
      .post(url + "/borrower/updatepersonal/new", {
        token,
        email,
        borrower_title: title,
        borrower_gender: gender,
        borrower_firstname: firstName,
        borrower_middlename: middleName,
        borrower_lastname: lastName,
        borrower_dob: dateOfBirth,
        borrower_education: educationalQualification,
        borrower_fathername: fathersName,
        borrower_mother_maiden: motherMaiden,
        borrower_motherTongue: motherTongue,
        borrower_category: category,
        borrower_religion: religion,
        borrower_uniqueno: id,
        borrower_voter_no: voterId,
      })
      .then((res) => {
        setOpen(false);
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setOpen(false);
        toast.error(err.message);
      });
  };

  useEffect(() => {
    setOpen(true);
    axios
      .post(url + "/borrower/getsingle", {
        token: token,
        email: email,
        borrower_uniqueno: id,
      })
      .then((res) => {
        // console.log(res.data);
        setTitle(res.data[0].borrower_title);
        setGender(res.data[0].borrower_gender);
        setFirstName(res.data[0].borrower_firstname);
        setMiddleName(res.data[0].borrower_middlename);
        setLastName(res.data[0].borrower_lastname);
        setDateOfBirth(res.data[0].borrower_dob);
        setEducationalQualification(res.data[0].borrower_education);
        setFathersName(res.data[0].borrower_fathername);
        setmotherMaiden(res.data[0].borrower_mother_maiden);
        setmotherTongue(res.data[0].borrower_motherTongue);
        setcategory(res.data[0].borrower_category);
        setreligion(res.data[0].borrower_religion);
        setVoterId(res.data[0].borrower_voter_no);
        setBorrowerEmail(res.data[0].borrower_email);
        setOpen(false);
      })
      .catch((err) => {
        setOpen(false)
        toast.error(err.message);
      });
    // eslint-disable-next-line
  }, [token, email]);

  return (
    <>
      <Sidebar click={openView} />
      <div
        className={`${isOpen ? "ml-[15%]" : "ml-0"
          } transition-all duration-200 p-6 bg-[#EDF5FF] min-h-screen`}
      >
        <div className="max-w-7xl mx-auto bg-white rounded-lg shadow p-8 mt-10">

          {/* BACK BUTTON */}
          <div className="w-full max-w-[90rem] mt-2 flex items-center gap-2">
            <ChevronLeftIcon className="w-5 h-5 text-blue-600" />
            <button
              onClick={() => navigate(`/single/borrower/details/${id}`)}
              className="text-blue-600 text-sm no-underline hover:no-underline"
            >
              Back to Borrower Details
            </button>
          </div>

          <h2 className="text-xl mt-8 font-semibold mb-8 flex items-center space-x-2">
            <span>Edit Core Personal Details</span>
          </h2>

          <form onSubmit={handleUpdatePersonalDetails} className="space-y-6">
            <div className="grid grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Title*</label>
                <select
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="MR">Mr</option>
                  <option value="MRS">Mrs</option>
                  <option value="MS">MS</option>
                  <option value="OTHERS">Others</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Gender*</label>
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="MALE">Male</option>
                  <option value="FEMALE">Female</option>
                  <option value="TRANSGENDER">Transgender</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name*</label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Middle Name</label>
                <input
                  type="text"
                  value={middleName}
                  onChange={(e) => setMiddleName(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Last Name*</label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Date Of Birth*</label>
                <input
                  type="date"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Educational Qualification*
                </label>
                <select
                  value={educationalQualification}
                  onChange={(e) => setEducationalQualification(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="ILLITERATE">ILLITERATE</option>
                  <option value="10TH">10TH</option>
                  <option value="12TH">12TH</option>
                  <option value="GRADUATE">GRADUATE</option>
                  <option value="POST-GRADUATE">POST-GRADUATE</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">E-mail*</label>
                <input
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                  value={borrowerEmail}
                  onChange={(e) => setBorrowerEmail(e.target.value)}
                  disabled
                  type="email"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Father Name*</label>
                <input
                  type="text"
                  value={fathersName}
                  onChange={(e) => setFathersName(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mother's Maiden name*</label>
                <input
                  type="text"
                  value={motherMaiden}
                  onChange={(e) => setmotherMaiden(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mother Tongue*</label>
                <select
                  value={motherTongue}
                  onChange={(e) => setmotherTongue(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="HINDI">Hindi</option>
                  <option value="GUJARATI">Gujarati</option>
                  <option value="ENGLISH">English</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Category*</label>
                <select
                  value={category}
                  onChange={(e) => setcategory(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="GENERAL">GENERAL</option>
                  <option value="SC">SC</option>
                  <option value="ST">ST</option>
                  <option value="OBC">OBC</option>
                  <option value="OTHER">OTHER</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Religion*</label>
                <select
                  value={religion}
                  onChange={(e) => setreligion(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="HINDU">Hindu</option>
                  <option value="MUSLIM">Muslim</option>
                  <option value="SIKH">Sikh</option>
                  <option value="CHRISTIAN">Christian</option>
                  <option value="JAIN">Jain</option>
                  <option value="BUDDHISM">Buddhism</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Voter ID</label>
                <input
                  type="text"
                  value={voterId}
                  onChange={(e) => setVoterId(e.target.value)}
                  className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-md text-sm font-medium shadow-sm"
              >
                UPDATE
              </button>
            </div>
          </form>
        </div>

        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default EditBorrowerScreen;


